// =============================================================================
// features/dashboard/components/SnapshotRow.tsx — KPIs de ESTADO ATUAL.
//
// A zona "Agora" da página: números que, por definição, não obedecem ao seletor
// de período. Não é limitação — é a semântica correta. "Quantos leads existem na
// base" e "quantos estão parados há 7 dias" são retratos do presente; filtrá-los
// por "Hoje" não teria significado.
//
// Antes esses números viviam misturados aos do período, sob o rótulo do período
// — que era exatamente o que fazia a tela mentir (diagnóstico D1).
// =============================================================================

import * as React from 'react';

import { Stat } from '../../../components/ui/Stat';
import type { KanbanMetrics, LeadsMetrics } from '../../../hooks/dashboard/types';

interface SnapshotRowProps {
  leads: LeadsMetrics;
  kanban: KanbanMetrics;
}

function fmtNumber(n: number): string {
  return n.toLocaleString('pt-BR');
}

export function SnapshotRow({ leads, kanban }: SnapshotRowProps): React.JSX.Element {
  const cardsInFunnel = kanban.cardsByStage.reduce((sum, s) => sum + s.count, 0);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <Stat
        label="Base de leads"
        value={fmtNumber(leads.totalAllTime)}
        description="total acumulado — não depende do período"
      />
      <Stat
        label="No funil"
        value={fmtNumber(cardsInFunnel)}
        description="cards em algum estágio do Kanban agora"
      />
      <Stat
        label="Parados"
        value={fmtNumber(leads.staleCount)}
        description="sem interação há mais de 7 dias"
      />
    </div>
  );
}

export function SnapshotRowSkeleton(): React.JSX.Element {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className="rounded-md border border-border bg-surface-1 p-5"
          style={{ boxShadow: 'var(--elev-2)', minHeight: '100px' }}
        >
          <div
            className="mb-3 h-2.5 w-24 rounded-pill animate-pulse"
            style={{ background: 'var(--surface-muted)' }}
          />
          <div
            className="h-8 w-16 rounded-xs animate-pulse"
            style={{ background: 'var(--surface-muted)' }}
          />
          <div
            className="mt-2 h-2 w-32 rounded-pill animate-pulse"
            style={{ background: 'var(--border-subtle)' }}
          />
        </div>
      ))}
    </div>
  );
}
